/**
 * Pure mapping logic for AdminFixturesPage, split out so it's testable
 * without going through MUI DataGrid's virtualized rendering (which doesn't
 * render row content in jsdom without real layout/ResizeObserver).
 */

// fixture_date/kick_off_time come from DWS as ISO instants; render them
// human-readable but fall back to the raw value if parsing fails rather
// than showing "Invalid Date".
export function formatFixtureDate(value) {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleDateString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatKickOffTime(value) {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function toRow(fixture) {
  return {
    id: fixture.fixture_id,
    fixtureName:
      fixture.fixture_name ||
      `${fixture.home_team?.team_short_name || fixture.home_team?.team_name || '?'} vs ${
        fixture.away_team?.team_short_name || fixture.away_team?.team_name || '?'
      }`,
    status: fixture.fixture_status || '—',
    date: formatFixtureDate(fixture.fixture_date),
    time: formatKickOffTime(fixture.kick_off_time),
    venue: fixture.venue?.venue_name || '—',
  };
}

export function buildFixtureTeamsPath(competitionId, seasonId, fixtureId) {
  return `/dashboard/admin-portal/competitions/${competitionId}/seasons/${seasonId}/fixtures/${fixtureId}/teams`;
}
